@if (faqData) {
  <div class="h-100 faqContent">
    @if (returnRoute) {
      <div class="goBack">
        <div class="container-fluid d-flex justify-content-start">
          <button (click)="goBack()" class="rs-btn-link  line-height-1 d-flex align-items-start">
            <span class="color-secondary icon icon-back-arrow"></span>
            <span class="color-secondary fs-22">Back</span>
          </button>
        </div>
      </div>
    }
    <div class="container-fluid d-flex justify-content-start">
      <h1>{{ faqData.config.title | translate }}</h1>
    </div>
    <div class="container-fluid questionsAnswers p-2">
      <h2><b>{{ faqData.config.questionsAnswers.title | translate }}</b></h2>
      @for (qa of faqData.config.questionsAnswers.groups; track qa) {
        <div class="qa">
          <h3>{{ qa.question | translate }}</h3>
          @for (answerSegment of qa.answer.segments; track answerSegment) {
            <div>
              @if (answerSegment.display === 'block') {
                <div class="answerSegment">
                  {{ answerSegment.values[0].text | translate }}
                </div>
              } @else {
                <ul>
                  @for (listItem of answerSegment.values; track listItem) {
                    <li>{{ listItem.text | translate }}</li>
                  }
                </ul>
              }
            </div>
          }
        </div>
      }
    </div>
    <div class="container-fluid definitions p-2">
      <h2><b>{{ faqData.config.definitions.title | translate }}</b></h2>
      <ul>
        @for (definitionGroup of faqData.config.definitions.groups; track definitionGroup) {
          <li>
            <b>{{ definitionGroup.word | translate }}</b>:
          {{ definitionGroup.definition |translate }} </li>
        }
      </ul>
    </div>
  </div>
}